import { useSelector } from "react-redux";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";

const FieldForceEditConfirm = (props) => {
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  return (
    <div className="beneBank_Main_edit  Qsmd:gap-gap-xl">
      <div className="dividebank_edit_confirm">
        <div className="w-width-md h-fit bankright_edit">
          <div className="w-full p-padding-md h-auto rounded-border-radius-md bg-primary-card">
            <div className=" text-text-primary">
              <p className=" text-font-md text-text-primary font-semibold">
                {" "}
                Bank Details
              </p>
              <div className="pt-padding-sm">
                <span className="text-text-primary font-normal text-font-md">
                  {formatAccountNumber(
                    bankStatus?.verification_details[0]?.bank_acc_no,
                  )}
                </span>
                <p className=" text-text-secondary mt-margin-xs text-font-xs font-normal">
                  Bank account number
                </p>
              </div>
              <div className="w-full h-fit flex justify-between">
                <div className="ifscCode">
                  <span className="text-text-primary font-normal text-font-md">
                    {bankStatus?.verification_details[0]?.ifsc_code}
                  </span>
                  <p className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    IFSC code
                  </p>
                </div>
                <div className="items-center justify-between h-10">
                  <div className="bankImg bg-text-primary rounded-tl-border-radius-md rounded-br-border-radius-mdr flex items-center justify-around mt-margin-md flex-shrink-0 ">
                    <IfscCodeMapper
                      ifscCode={bankStatus?.verification_details[0]?.ifsc_code}
                    />
                  </div>
                </div>
              </div>

              <div className="pt-padding-sm">
                <span className="text-text-primary font-normal text-font-md">
                  {bankStatus?.verification_details[0]?.full_name.toLowerCase()}
                </span>

                <p className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                  {bankStatus?.verification_details[0].is_virtual === "Y"
                    ? "Account holder's name - Using legal name"
                    : "Account holder's name"}
                </p>
              </div>
              <div className=" border border-primary-bg my-margin-sm  w-full "></div>
            </div>
            <div className=" text-text-primary">
              <p className="text-font-md text-text-primary font-semibold">
                Address Details
              </p>
              <>
                <div className=" mt-margin-sm">
                  <div className="w-full antaliased text-text-primary font-normal text-font-md capitalize self-center text-base truncate ...">
                    {bankStatus?.verification_details[0].branch
                      ? bankStatus?.verification_details[0].branch.toLowerCase()
                      : "NA"}
                  </div>
                  <div className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    Branch
                  </div>
                </div>
                <div className=" mt-margin-sm">
                  <div className="w-full text-text-primary font-normal text-font-md  capitalize  self-center text-base truncate ...">
                    {bankStatus?.verification_details[0].city
                      ? bankStatus?.verification_details[0].city.toLowerCase()
                      : "NA"}
                  </div>
                  <div className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    City
                  </div>
                </div>
                <div className=" mt-margin-sm">
                  <div className="w-full antaliased  text-text-primary font-normal text-font-md capitalize  self-center text-base truncate ...">
                    {bankStatus?.verification_details[0].district
                      ? bankStatus?.verification_details[0].district.toLowerCase()
                      : "NA"}
                  </div>
                  <div className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    District
                  </div>
                </div>
                <div className=" mt-margin-sm">
                  <div className="pr-padding-md w-full antialiased text-text-primary font-normal text-font-md capitalize text-base whitespace-pre-line break-words overflow-ellipsis">
                    {bankStatus?.verification_details[0].address
                      ? bankStatus?.verification_details[0].address.toLowerCase()
                      : "NA"}
                  </div>
                  <div className="text-text-secondary mt-margin-xs text-font-xs font-normal">
                    Address
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div className="dividebank_edit_confirm">
        <div className="bankleft_edit">
          <div className="w-full h-auto  p-padding-md rounded-border-radius-md bg-primary-card custom-boxShadow">
            <div className=" text-text-secondary">
              <p className="text-text-primary font-semibold text-font-md">
                Archive Account Details
              </p>
              <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                This account will be archived.
              </p>
              <div className=" border border-primary-bg w-full my-margin-sm"></div>
              <div className="pb-padding-sm">
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md">
                  {props?.payload?.pan_no && props?.payload?.gstin_detail
                    ? "Beneficiary PAN & GSTIN Details"
                    : " PAN Details"}
                </h5>
                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.pan_no}
                </span>
                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  PAN details
                </p>

                {props?.payload?.gstin_detail ? (
                  <div className=" mt-margin-sm">
                    <span className="text-text-primary font-normal text-font-md">
                      {props?.payload?.gstin_detail}
                    </span>
                    <p className="text-text-secondary font-normal text-font-xs">
                      GST details
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className=" border border-primary-bg w-full "></div>
              <div className=" pt-padding-sm">
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md capitalize">
                  Bank details
                </h5>
                <span className="text-text-primary font-normal text-font-md">
                  {formatAccountNumber(props?.payload?.old_bank_account)}
                </span>
                <p className="text-text-secondary mb-margin-sm font-normal text-font-xs">
                  Bank account number
                </p>
                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.old_ifsc_code}
                </span>
                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  IFSC code
                </p>
              </div>
              <div className=" border border-primary-bg my-margin-sm w-full"></div>
              <div>
                <h5 className="text-text-primary font-semibold mb-margin-sm text-font-md capitalize">
                  Contact Details
                </h5>
                <span className="capitalize text-text-primary font-normal mt-margin-sm text-font-md">
                  {props?.payload?.legal_name.toLowerCase()}
                </span>
                <p className="text-text-secondary font-normal mb-margin-sm mt-margin-xs text-font-xs">
                  Beneficiary name - Using legal name
                </p>
                <span className="text-text-primary font-normal mt-margin-sm text-font-md">
                  +91 {props?.payload?.contact_no}
                </span>
                <p className="text-text-secondary font-normal my-margin-sm mt-margin-xs text-font-xs">
                  Contact number
                </p>

                <p
                  id="email-id-firstLetter"
                  className=" text-text-primary font-normal mt-margin-sm overflow-ellipsis w-width-almost-fulltext-font-md overflow-hidden whitespace-nowrap "
                >
                  {props?.payload?.email_id}
                </p>

                <p className="text-text-secondary font-normal mt-margin-xs text-font-xs">
                  Email Id
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceEditConfirm;
